import styled, { css } from "styled-components"

const StyledSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.gridWidth};
  padding: 7.2rem ${({ theme }) => theme.layout.mobilePadding} 6.4em;

  ${({ theme }) => theme.mq.medium} {
    padding: 7.2rem ${({ theme }) => theme.layout.mobilePadding} 11.2rem;
  }
`
const StyledListWrapper = styled.div`
  max-width: 76.8rem;
  margin-top: 4.8rem;
  width: 100%;

  .my-masonry-grid {
    display: flex;
    margin-left: -3.2rem;
    width: auto;
  }

  .my-masonry-grid_column {
    padding-left: 3.2rem;
    background-clip: padding-box;

    &:nth-child(2) {
      margin-top: 10.4rem;
    }
  }

  ${({ theme }) => theme.mq.medium} {
    margin-top: 9.6rem;
    width: fit-content;
  }
`

const StyledHeadingWrapper = styled.div`
  text-align: center;
  margin: 8rem 0 6.6rem;

  ${({ theme }) => theme.mq.medium} {
    margin: 9.6rem 0;
  }
`

const headingStyles = css`
  position: relative;
  word-wrap: break-word;
  font-size: 4.8rem;
  line-height: 1.25;
  display: inline;
  box-shadow: inset 0 -0.2em white,
    inset 0 -0.3em ${({ theme }) => theme.color.senary03};

  ${({ theme }) => theme.mq.medium} {
    margin: 9.6rem 0;
    font-size: 7.2rem;
    line-height: 1.1;
  }
`
const subHeadingStyles = css`
  max-width: 36.8rem;
  font-size: 3.2rem;
  line-height: 1.25;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0.8rem;
    text-align: center;
  }
`
const mainTextStyles = css`
  max-width: 36.8rem;
  margin-bottom: 4.8rem;
  font-size: ${({ theme }) => theme.font.size.l};
  line-height: 1.78;

  ${({ theme }) => theme.mq.medium} {
    text-align: center;
  }
`
export {
  StyledSectionWrapper,
  StyledListWrapper,
  StyledHeadingWrapper,
  headingStyles,
  subHeadingStyles,
  mainTextStyles,
}
